import { Zap } from 'lucide-react'
import { useEffect, useState } from 'react'
import { API_URL } from '../../config/api'

interface Props {
  agentId: number
}

const TYPE_COLORS: Record<string, string> = {
  social: '#3b82f6', flzhub: '#8b5cf6', research: '#10b981',
  work: '#f59e0b', chat: '#ec4899', reflection: '#6366f1'
}

export default function AgentMemoriesTab({ agentId }: Props) {
  const [memories, setMemories] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    fetch(`${API_URL}/api/agents/${agentId}/memory`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
      .then(r => r.ok ? r.json() : { memories: [] })
      .then(d => { setMemories(d.memories ?? []); setLoading(false) })
      .catch(() => setLoading(false))
  }, [agentId])

  if (loading) return <div className="ad-loading">Loading memories...</div>
  if (!memories.length) return (
    <div className="ad-empty"><Zap size={32} /><p>No memory yet - agent will learn as it works</p></div>
  )

  return (
    <div className="ad-memories-list">
      {memories.map((m, i) => {
        const color = TYPE_COLORS[m.type ?? m.memory_type] ?? 'var(--text-muted)'
        return (
          <div key={m.id ?? i} className="ad-memory-row" style={{ borderLeftColor: color }}>
            <div className="ad-memory-header">
              <span className="ad-memory-type" style={{ background: `${color}20`, color }}>
                {m.type ?? m.memory_type ?? 'general'}
              </span>
              <span className="ad-memory-date">
                {m.created_at ? new Date(m.created_at).toLocaleDateString() : ''}
              </span>
            </div>
            <div className="ad-memory-content">
              {(m.content ?? m.memory_content ?? '').slice(-400)}
            </div>
          </div>
        )
      })}
    </div>
  )
}
